export const DEFAULT_METRIC_COLUMN_WIDTH = 192;
export const METRIC_COLUMN_MIN_WIDTH = 130;
export const EXPANDER_COLUMN_WIDTH = 40;

export const expanderColumnSx = {
  width: EXPANDER_COLUMN_WIDTH,
  minWidth: EXPANDER_COLUMN_WIDTH,
  maxWidth: EXPANDER_COLUMN_WIDTH,
  padding: "0px !important",
  overflow: "visible",
  textAlign: "center",
  "& .MuiIconButton-root": {
    padding: "4px",
  },
};

export const metricColumnSx = (width = DEFAULT_METRIC_COLUMN_WIDTH) => ({
  width,
  minWidth: METRIC_COLUMN_MIN_WIDTH,
});
